export type SavedScrollPosition = { left: number; top: number }

type NavigationState = {
  isBack: boolean
  savedPosition: SavedScrollPosition | null
}

let navigationState: NavigationState = {
  isBack: false,
  savedPosition: null,
}

/** Called from router scrollBehavior on every navigation. */
export function markRouterNavigation(savedPosition: SavedScrollPosition | null | undefined) {
  navigationState = {
    isBack: savedPosition != null,
    savedPosition: savedPosition ?? null,
  }
}

export function peekIsBackNavigation(): boolean {
  return navigationState.isBack
}

export function peekSavedScrollPosition(): SavedScrollPosition | null {
  return navigationState.savedPosition
}

/** Strip optional locale prefix (/bg, /en). */
function stripLocale(path: string): string {
  return path.replace(/^\/(bg|en)(?=\/|$)/, '') || '/'
}

/**
 * Product detail: /category/:cat/:id-slug (id starts with digits).
 * Brand listings under /category/:cat/:brand are not product pages.
 */
export function isProductDetailPath(path: string): boolean {
  const cleaned = stripLocale(path.split('?')[0] || path)
  const nested = cleaned.match(/^\/category\/[^/]+\/([^/]+)\/?$/)
  return !!nested?.[1] && /^\d+-/.test(nested[1])
}

/**
 * Paths where list scroll restore owns scrolling on back navigation.
 * Product detail URLs under /category/:cat/:id-slug are excluded.
 */
export function isListScrollPath(path: string): boolean {
  const cleaned = stripLocale(path.split('?')[0] || path)

  if (/^\/search\/?$/.test(cleaned)) return true
  if (/^\/favourites\/?$/.test(cleaned)) return true
  if (/^\/offers\/?$/.test(cleaned)) return true

  // Category index: /category/:slug
  if (/^\/category\/[^/]+\/?$/.test(cleaned)) return true

  // Brand listing shares the product route file but is not a product id-slug.
  const nested = cleaned.match(/^\/category\/[^/]+\/([^/]+)\/?$/)
  if (nested?.[1]) {
    return !/^\d+-/.test(nested[1])
  }

  return false
}
